
<template>
  <div class="banner">
    <div
      class="banner-title ellipsis"
      :class="titleClassName"
    >{{ benefitName }}</div>
    <div
      class="banner-image"
      :style="{ backgroundImage: 'url(' + getImage + ')' }"
    ></div>
  </div>
</template>

<script>
import bannerGlobal from '@/assets/images/c/new_coupon_global_banner_bg.png'
import banner99 from '@/assets/images/c/new_coupon_99_banner_bg.png'
export default {
  name: 'NewCouponBanner',
  props: {
    benefitName: {
      default: ''
    },
    image: {
      default: ''
    }
  },
  computed: {
    titleClassName () {
      let { width } = this.textSize('Aspira Demi', this.benefitName)
      const LIMIT_WIDTH = 202 * 2
      document.querySelector('#virtualEle').remove()
      return width < LIMIT_WIDTH ? 'banner-title-big' : 'banner-title-small'
    },
    // 获取对应的国家
    getCountry () {
      return this.$store.state.country
    },
    getImage () {
      let banner = this.getCountry === 'BR' ? banner99 : bannerGlobal
      if (this.image) banner = this.image
      return banner
    }
  },
  methods: {
    textSize (fontFamily, text) {
      const span = document.createElement('span')
      const result = {}
      result.width = span.offsetWidth
      span.id = 'virtualEle'
      span.style.visibility = 'hidden'
      span.style.position = 'absolute'
      span.style.whiteSpace = 'nowrap'
      span.style.top = 0
      span.style.top = 0
      span.style.zIndex = -1
      span.style.fontFamily = fontFamily
      span.style.display = 'inline-block'
      document.querySelector('#app').appendChild(span)
      if (typeof span.textContent !== 'undefined') {
        span.textContent = text
      } else {
        span.innerText = text
      }
      result.width =
        parseFloat(window.getComputedStyle(span).width) - result.width
      return result
    }
  }
}
</script>
<style lang="scss">
#virtualEle {
  font-size: 60px;
}
</style>
<style lang="scss" scoped>
@import "~@/assets/styles/var.scss";

.banner {
  height: 360px;
  @include background-gradient(180deg);
  overflow: hidden;
  position: relative;
}
// 两行超出省略
.ellipsis {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break:break-all;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.banner-title {
  font-family: "Aspira Demi";
  color: #ffffff;
  font-weight: 500;
  margin-top: 192px;
  margin-left: 42px;
  margin-right: 304px;

}
.banner-title-big {
  font-size: 60px;
  line-height: 66px;
}
.banner-title-small {
  font-size: 48px;
  line-height: 56px;
}
.banner-image {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 304px;
  height: 100%;
  background-size: 100% 100%;
}
</style>
